type IntlWeekday = 'long' | 'short' | 'narrow' | undefined

function getIntlWeekDays(localeName: string = navigator.language, weekday: IntlWeekday = 'long') {
  const numberDaysWeek = 7
  const format = new Intl.DateTimeFormat(localeName, {weekday}).format
  const numbersOfweek = [...Array(numberDaysWeek).keys()]

  return numbersOfweek.map(day => format(Date.UTC(0, 0, day)))
}

export default getIntlWeekDays
